import React from 'react'
import { t } from 'i18next'

const Dashboard = React.lazy(() => import('./views/dashboard/Dashboard'))
const ResolveQuestions = React.lazy(() =>
  import('./views/student/resolveQuestions/ResolveQuestions'),
)
const MyBooks = React.lazy(() => import('./views/student/myBooks/MyBooks'))
const MockTests = React.lazy(() => import('./views/student/mockTests/MockTests'))
const DoMockTest = React.lazy(() => import('./views/student/doMockTest/DoMockTest'))
const MyStudyPlans = React.lazy(() => import('./views/student/myStudyPlans/MyStudyPlans'))
const MyPerformance = React.lazy(() => import('./views/student/myPerformance/MyPerformance'))
const MyStudents = React.lazy(() => import('./views/manager/myStudents/MyStudents'))
const Students = React.lazy(() => import('./views/manager/students/Students'))
const Members = React.lazy(() => import('./views/manager/members/Members'))
const Supervisors = React.lazy(() => import('./views/manager/supervisors/Supervisors'))
const Teachers = React.lazy(() => import('./views/manager/teachers/Teachers'))
const StudyGroups = React.lazy(() => import('./views/manager/studyGroups/StudyGroups'))
const Authors = React.lazy(() => import('./views/manager/authors/Authors'))
const Reports = React.lazy(() => import('./views/manager/reports/Reports'))
const Questions = React.lazy(() => import('./views/manager/questions/Questions'))
const MockTestsManage = React.lazy(() => import('./views/manager/mockTests/MockTests'))
const CreateMockTestManage = React.lazy(() =>
  import('./views/manager/createMockTest/CreateMockTest'),
)
const EditMockTestManage = React.lazy(() => import('./views/manager/editMockTest/EditMockTest'))
const ManageMockTestQuestions = React.lazy(() =>
  import('./views/manager/manageMockTestQuestions/ManageMockTestQuestions'),
)
const Subscription = React.lazy(() => import('./views/user/subscription/Subscription'))
const TestResultsReport = React.lazy(() => import('./views/manager/reports/TestResults'))
const TestStudentResultsReport = React.lazy(() =>
  import('./views/manager/reports/TestStudentResults'),
)

const routes = [
  { path: '/', exact: true, name: t('Home') },
  { path: '/dashboard', name: t('Dashboard'), element: Dashboard },
  { path: '/questions', name: t('Questions'), element: ResolveQuestions },
  { path: '/my-books', name: t('My Books'), element: MyBooks },
  { path: '/mock-tests', name: t('Mock Tests'), element: MockTests },
  { path: '/mock-tests/:id', name: t('Do Mock Test'), element: DoMockTest },
  { path: '/my-plans', name: t('My Study Plans'), element: MyStudyPlans },
  { path: '/my-performance', name: t('My Performance'), element: MyPerformance },
  { path: '/reports', name: t('Reports'), element: Reports },
  { path: '/reports/subject/:id/questions', name: t('Questions'), element: Questions },
  { path: '/manager/my-students', name: t('My Students'), element: MyStudents },
  { path: '/manager/students', name: t('Students'), element: Students },
  { path: '/manager/members', name: t('Members'), element: Members },
  { path: '/manager/supervisors', name: t('Supervisors'), element: Supervisors },
  { path: '/manager/teachers', name: t('Teachers'), element: Teachers },
  { path: '/manager/study-groups', name: t('Study Groups'), element: StudyGroups },
  { path: '/manager/authors', name: t('Authors'), element: Authors },
  { path: '/manager/mock-tests', name: t('Mock Tests'), element: MockTestsManage },
  {
    path: '/manager/mock-tests/create',
    name: t('Create Mock Test'),
    element: CreateMockTestManage,
  },
  { path: '/manager/mock-tests/:id/edit', name: t('Mock Tests Edit'), element: EditMockTestManage },
  {
    path: '/manager/mock-tests/:id/edit/questions',
    name: t('Manage Mock Test Questions'),
    element: ManageMockTestQuestions,
  },
  { path: '/manager/mock-tests/:id/results', name: t('Results'), element: TestResultsReport },
  {
    path: '/manager/mock-tests/:test/student/:student/results',
    name: t('Results per student'),
    element: TestStudentResultsReport,
  },
  { path: '/subscription', name: t('Subscription'), element: Subscription },
]

export default routes
